const SideMenu = ({
  categories = [],
  activeCategory,
  onCategoryChange,
}) => {
  const formatCategory = (category) => {
    return String(category)
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  return (
    <nav className="menuCategories" aria-label="Menu categories">
      <div className="menuCategoriesTrack">
        {categories.map((category, index) => (
          <button
            type="button"
            key={`${category}-${index}`}
            className={`menuCategory ${
              activeCategory === category
                ? "isActive"
                : ""
            }`}
            onClick={() => onCategoryChange(category)}
          >
            <span>{formatCategory(category)}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default SideMenu;